import DockContent from './DockContent';

/**
 * GlassDock - Desktop-only floating filter dock
 * Wraps DockContent with glass-pill styling
 * Hidden on mobile via CSS
 */
export default function GlassDock() {
  return (
    <div className="glass-dock">
      <DockContent />
    </div>
  );
}
